export default {
  container: {
    borderRadius: 20,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "stretch",
  },
  textContainer: {
    flex: 1,
    fontFamily: "roboto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 10,
    fontWeight: "bold",
    textAlign: "center",
  },
  leftButton: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 0,
    border: "1px solid #FFFFFF55",
    flex: 1,
  },
  rightButton: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 20,
    border: "1px solid #FFFFFF55",
    flex: 1,
  },
};
